<template>
  <div>
    <el-row>
      <el-col>
        <el-row>
          <el-col :span="24">
            <el-row>
              <el-col class="text-right" v-if="USERMANAGER.isAdmin">
                <el-button type="danger" :loading="this.isDisableLoading" size="medium" @click="statusToggleAll(false)">
                  禁用所有
                </el-button>
                <el-button class="enable-all-button" :loading="this.isEnableLoading" size="medium" @click="statusToggleAll(true)">
                  解禁所有
                </el-button>
                <!-- <el-button type="primary" size="medium" @click="uploadTest('FrontEnd')">
                                                上传测试 
                                            </el-button> -->
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="cs-filter-row">
          <el-col :span="24">
            <el-row>
              <el-col :span="5">
                <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search" v-model.trim="searchCondition.phone"
                  @change="onSearchConditionChanged" @keyup.enter.native="onSearchConditionChanged"> </el-input>
              </el-col>
              <el-col :span="5"
                v-if="USERMANAGER.isAdmin || USERMANAGER.isFinancialManager || USERMANAGER.isExecutiveManager || USERMANAGER.isRegionCEO">
                <el-select placeholder="大学" v-model="searchCondition.universityId" @change="onUniversityChange" size="medium" filterable
                  class="margin-left-20px">
                  <el-option v-for="item in universityList" :key="item.Key" :label="item.Value" :value="item.Key">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="5" v-if="USERMANAGER.isAdmin || USERMANAGER.isFinancialManager || USERMANAGER.isRegionCEO">
                <el-select placeholder="登记状态" v-model="searchCondition.isConfigured" @change="onSearchConditionChanged"
                  size="medium" class="margin-left-20px">
                  <el-option v-for="item in configurations" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="5" v-if="USERMANAGER.isAdmin || USERMANAGER.isFinancialManager || USERMANAGER.isRegionCEO">
                <el-select placeholder="学生类型" v-model="searchCondition.isAuld" @change="onSearchConditionChanged" size="medium"
                  class="margin-left-20px">
                  <el-option v-for="item in studentTypeList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="margin-top-10" v-if="USERMANAGER.isAdmin || USERMANAGER.isFinancialManager || USERMANAGER.isRegionCEO">
              <el-col :span="5">
                <el-select placeholder="报课状态" v-model="searchCondition.isEnroll" @change="onSearchConditionChanged" size="medium">
                  <el-option v-for="item in applyCourseStatus" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-select placeholder="课程类型" v-model="searchCondition.courseType" @change="onSearchConditionChanged"
                  size="medium" class="margin-left-20px">
                  <el-option v-for="item in courseTypeList" :key="item.Key" :label="item.Value" :value="item.Key">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="5" v-if="searchCondition.courseType == 2 || searchCondition.courseType == 3">
                <el-select v-if="searchCondition.courseType == 2" placeholder="业务" v-model="searchCondition.englishCategoryId"
                  @change="onSearchConditionChanged" size="medium" class="margin-left-20px">
                  <el-option v-for="item in englishCategoryList" :key="item.Id" :label="item.Name" :value="item.Id">
                  </el-option>
                </el-select>
                <el-select v-if="searchCondition.courseType == 3" placeholder="业务" v-model="searchCondition.trainingCategoryId"
                  @change="onTrainingCategoryChange" size="medium" class="margin-left-20px">
                  <el-option v-for="item in trainingCategoryList" :key="item.Id" :label="item.Name" :value="item.Id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-select v-show="searchCondition.courseType == 1" placeholder="学期" v-model="searchCondition.termId"
                  @change="onSearchConditionChanged" size="medium" class="margin-left-20px">
                  <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id">
                  </el-option>
                </el-select>
                <el-select v-show="searchCondition.courseType == 3 && !!searchCondition.trainingCategoryId" placeholder="学期"
                  v-model="searchCondition.trainingTermId" @change="onSearchConditionChanged" size="medium"
                  class="margin-left-20px">
                  <el-option v-for="item in trainingTermList" :key="item.Id" :label="item.DisplayLable" :value="item.Id">
                  </el-option>
                </el-select>
              </el-col>
              <!-- <el-col :span="5">
                                            <el-select placeholder="报课状态" v-model="searchCondition.isApplyCourse" @change="onSearchConditionChanged" size="medium" class="margin-left-20px">
                                                <el-option v-for="item in applyCourseStatus" :key="item.value" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-col> -->
            </el-row>
          </el-col>

        </el-row>
        <hr />
        <el-row v-if="displaySummary">
          <el-col :span="22">
            <el-row v-if="!displayAEOnly && !displayTrainingOnly">
              <el-col :span="6">
                <span>大学补习总积分：{{studentFinancialSummary.TotalBonusPoint}}</span>
              </el-col>
              <el-col :span="6">
                <span class="margin-left-20px">大学补习总旧余额：{{studentFinancialSummary.TotalBalance | toCurrency}}</span>
              </el-col>
              <el-col :span="6">
                <span class="margin-left-20px">大学补习总新余额：{{studentFinancialSummary.TotalNewBalance | toCurrency}}</span>
              </el-col>
              <el-col :span="6">
                <span class="margin-left-20px">大学补习总赠送余额：{{studentFinancialSummary.TotalGiftBalance | toCurrency}}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" v-if="!displayTrainingOnly">
                <span>大学补习总占位：{{studentFinancialSummary.TotalAECount}}</span><i
                  class="fa fa-info-circle cs-studentList-aeDetail-btn" aria-hidden="true" @click="onClickTotalAECount"></i>
              </el-col>
              <el-col :span="6" v-if="!displayTrainingOnly">
                <span class="margin-left-20px">大学补习可用总占位：{{studentFinancialSummary.TotalAEAvailableCount}}</span>
              </el-col>
              <el-col :span="6" v-if="!displayAEOnly">
                <span class="margin-left-20px">职业培训总占位：{{studentFinancialSummary.TotalTrainingAECount}}</span>
              </el-col>
              <el-col :span="6" v-if="!displayAEOnly">
                <span class="margin-left-20px">职业培训可用总占位：{{studentFinancialSummary.TotalTrainingAEAvailableCount}}</span>
              </el-col>
            </el-row>
            <el-row v-if="!displayAEOnly && !displayTrainingOnly">
              <el-col :span="6">
                <span v-loading="isLoadVipUnconsumedTotalAmount">VIP未消耗：{{vipUnconsumedTotalAmount | toCurrency}}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row class="grid-content">
          <el-col>
            <el-table v-loading="loading" :data="studentList" :cell-class-name="cellStyle"
              :header-row-class-name="'el-table-header'">
              <el-table-column prop="Phone" label="电话号码" width="120">
                <template slot-scope="scope">
                  <div>
                    <span class="cs-studentList-Phone" @click="showStudentProfile(scope.row)"> {{scope.row.Phone}}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="UniversityName" label="所属大学" width="100">
              </el-table-column>
              <el-table-column prop="SpeedupCourseNames" label="报名课程" width="400">
              </el-table-column>
              <el-table-column prop="IsConfigured" label="登记在校课程" width="150">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.IsConfigured">是</span>
                    <el-button :class="{'margin-left-20px':true, 'isClicked':checkIsClicked(scope.$index)}"
                      v-if="scope.row.IsConfigured" size="medium" type="text"
                      @click="showStudentCourseSchedule(scope.$index, scope.row)"> 查看
                    </el-button>
                    <span v-if="!scope.row.IsConfigured">否</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="IsMember" label="会员类型" width="100">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.IsMember">会员</span>
                    <span v-if="!scope.row.IsMember">非会员</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="IsMember" label="学生类型" width="100">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.IsAuld">非新生</span>
                    <span v-if="!scope.row.IsAuld">新生</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="BonusPoint" label="积分" width="80">
              </el-table-column>
              <el-table-column prop="Balance" label="旧余额" width="80">
                <template slot-scope="scope">
                  <div>
                    <span>{{scope.row.Balance | toCurrency}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="Balance" label="新余额" width="80">
                <template slot-scope="scope">
                  <div>
                    <span>{{scope.row.NewBalance | toCurrency}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="Balance" label="赠送余额" width="80">
                <template slot-scope="scope">
                  <div>
                    <span>{{scope.row.GiftBalance | toCurrency}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="AdvanceEnrollmentCount" label="大学占位" width="80">
                <template slot-scope="scope">
                  <div>
                    <span>{{scope.row.AdvanceEnrollmentCount}}({{scope.row.AdvanceEnrollmentCount - scope.row.AdvanceEnrollmentCountUsed}})</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="TrainingAdvanceEnrollmentCount" label="职业培训占位" width="80">
                <template slot-scope="scope">
                  <div>
                    <span>{{scope.row.TrainingAdvanceEnrollmentCount}}({{scope.row.TrainingAdvanceEnrollmentCount - scope.row.TrainingAdvanceEnrollmentCountUsed}})</span>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="WechatUnionId" label="微信Id" width="160" v-if="USERMANAGER.isAdmin">
                                        </el-table-column> -->
              <el-table-column prop="Enable" label="禁用" v-if="USERMANAGER.isAdmin">
                <template slot-scope="scope">
                  <div class="disable-icon" v-if="!scope.row.Enable" @click="statusToggle(scope.$index, scope.row)">
                    <img src="../../assets/disabled.png" alt="">
                  </div>
                  <div class="disable-icon" v-if="scope.row.Enable" @click="statusToggle(scope.$index, scope.row)">
                    <img src="../../assets/enable.png" alt="">
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="[20, 50, 100]" :page-size="20"
              layout="total, sizes, prev, pager, next, jumper" :total="recordTotal">
            </el-pagination>

          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-dialog center title="上传文件" :show-close="fileUploaderCloseVisible" :close-on-click-modal="false" width="700px"
      :visible.sync="fileUploaderVisible" top="8vh">
      <file-uploader v-on:closeEditor="onCloseEditor" v-on:fileUploaded="onFileUploaded"
        v-on:fileBeforeUpload="onFileBeforeUpload" v-on:fileUploadError="onFileUploadError" :submitBtnText="'确认导入'"
        :isVisible="fileUploaderVisible" :limit="1" :accepts="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
        :tips="'只能上传格式为.xlsx的文件'" :type="{type:'Student'}" :supportedFile="'.xlsx'"></file-uploader>
    </el-dialog>

    <el-dialog title="在校课程时间表" class="cs-studentCourseReview" :center="true" :close-on-click-modal="false" width="70%"
      :visible.sync="displayStudentCourse" top="5vh">
      <studentCourseReview :data="currentStudentData" @close="closeStudentCourse"
        v-on:dialogFormVisibleEvent="onDialogFormVisibleEvent"></studentCourseReview>
    </el-dialog>
    <el-dialog title="占位详情" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayAEDetail" top="5vh">
      <el-row class="cs-aeDetail-main">
        <el-col>
          <el-row>
            <el-col :span="8">&nbsp;</el-col>
            <el-col :span="8">人数</el-col>
            <el-col :span="8">占位/人</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">大学总占位: {{studentFinancialSummary.TotalAECount}}</el-col>
            <el-col :span="8">{{studentFinancialSummary.TotalAEStudentCount}}</el-col>
            <el-col :span="8">{{studentFinancialSummary.AverageAECount}}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">从未报课占位: {{studentFinancialSummary.TotalAECountNoCourse}}</el-col>
            <el-col :span="8">{{studentFinancialSummary.TotalAEStudentCountNoCourse}}</el-col>
            <el-col :span="8">{{studentFinancialSummary.AverageAECountNoCourse}}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">本学期报课且占位: {{studentFinancialSummary.TotalAECountCurrent}}</el-col>
            <el-col :span="8">{{studentFinancialSummary.TotalAEStudentCountCurrent}}</el-col>
            <el-col :span="8">{{studentFinancialSummary.AverageAECountCurrent}}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">本学期未报课且占位: {{studentFinancialSummary.TotalAECountPrevious}}</el-col>
            <el-col :span="8">{{studentFinancialSummary.TotalAEStudentCountPrevious}}</el-col>
            <el-col :span="8">{{studentFinancialSummary.AverageAECountPrevious}}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">大学可用占位: {{studentFinancialSummary.TotalAEAvailableCount}}</el-col>
            <el-col :span="8">{{studentFinancialSummary.TotalAEAvailableStudentCount}}</el-col>
            <el-col :span="8">{{studentFinancialSummary.AverageAEAvailableCount}}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">本学期报课未占位: </el-col>
            <el-col :span="8">{{studentFinancialSummary.TotalStudentCountNoCurrentAE}}</el-col>
          </el-row>
          <el-row>
            <el-col>&nbsp;</el-col>
          </el-row>
          <el-row>
            <el-col :span="6">&nbsp;</el-col>
            <el-col :span="6">占位数</el-col>
            <el-col :span="6">人数</el-col>
            <el-col :span="6">占位/人</el-col>
          </el-row>
          <el-row v-for="(item, index) in studentFinancialSummary.AETypeSummryDataList" :key="index">
            <el-col :span="6">{{item.Comment == "" ? "N/A": item.Comment}}</el-col>
            <el-col :span="6">{{item.TotalAECount}}</el-col>
            <el-col :span="6">{{item.TotalAEStudentCount}}</el-col>
            <el-col :span="6">{{item.AverageAE}}</el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.cs-studentCourseReview {
  padding-left: 40px;
  padding-right: 40px;
}

.cs-aeDetail-main {
  padding: 40px;
}
.cs-studentList-aeDetail-btn {
  cursor: pointer;
  color: #409eff;
  margin-left: 5px;
  font-size: 1rem;
}
body .cs-filter-row {
  padding-top: 10px;
}
.cs-contentContainer {
  .grid-content {
    margin-top: 15px;

    .cs-schedule-buttonContainer {
      text-align: right;
    }

    .cs-studentList-Phone {
      color: #409eff;
      cursor: pointer;
    }
  }

  .cs-schedule-bottomButton {
    margin-top: 20px;
  }

  .disable-all-button {
    color: #fff;
    background-color: rgba(230, 66, 70, 80%);
    border-color: rgba(230, 66, 70, 80%);
  }

  .disable-all-button:hover {
    background-color: rgba(230, 66, 70, 100%);
    border-color: rgba(230, 66, 70, 100%);
  }

  .enable-all-button {
    color: #fff;
    background-color: rgb(179, 52, 60);
    border-color: rgb(179, 52, 60);
  }

  .enable-all-button:hover {
    background-color: rgba(230, 66, 70, 100%);
    border-color: rgba(230, 66, 70, 100%);
  }
}
</style>

<script>
import {
  getUniversities,
  getTerms,
  getTrainingTerms,
  getTrainingCategoryList,
} from "../../service/common.service";
import { getCourseTypeList } from "../../config/mUtils";
import {
  getStudentSpeedupCourse,
  disableStudent,
  disableStudentAll,
  enableStudent,
  enableStudentAll,
  importStudentSpeedupCourse,
  getStudentFinacialSummary,
} from "../../service/student.service";
import {
  getVipUnconsumedTotalAmount,
} from "../../service/finance.service";
import navigator from "../../components/navigator";
import fileUploader from "../../components/fileHandler/fileUploader";
import phoneEditorVue from "../../components/phoneEditor.vue";
import studentCourseReview from "../../components/studentCourseReview.vue";
export default {
  props: {
    isActive: Boolean,
  },
  data() {
    getUniversities(true).then((result) => {
      if (!!result && result.success) {
        this.universityList = this.universityList.concat(result.data);
      }
    });
    return {
      currentStudentData: {},
      displayStudentCourse: false,
      currentPageSize: 20,
      recordTotal: 0,
      currentPage: 1,
      loading: false,
      isDisableLoading: false,
      isEnableLoading: false,
      fileUploaderVisible: false,
      fileUploaderCloseVisible: true,
      universityList: [
        {
          Key: "",
          Value: "所有学校",
        },
      ],
      configurations: [
        {
          value: "",
          label: "不限登记状态",
        },
        {
          value: false,
          label: "未登记",
        },
        {
          value: true,
          label: "已登记",
        },
      ],
      enrollList: [
        {
          value: "",
          label: "不限报名状态",
        },
        {
          value: false,
          label: "未报名",
        },
        {
          value: true,
          label: "已报名",
        },
      ],
      studentTypeList: [
        {
          value: "",
          label: "不限学生类型",
        },
        {
          value: false,
          label: "新生",
        },
        {
          value: true,
          label: "非新生",
        },
      ],
      applyCourseStatus: [
        {
          value: "",
          label: "不限报课状态",
        },
        {
          value: true,
          label: "已报课",
        },
        {
          value: false,
          label: "未报课",
        },
      ],
      searchCondition: {
        phone: "",
        universityId: "",
        isConfigured: "",
        isEnroll: "",
        termId: "",
        isAuld: "",
        isApplyCourse: "",
        courseType: "",
        courseCode: "",
        trainingTermId: "",
        trainingCategoryId: "",
        englishCategoryId: "",
      },
      studentList: [],
      clickedStudentList: [],
      currentTermId: 0,
      termList: [],
      studentFinancialSummary: {},
      courseTypeList: [],
      trainingTermList: [],
      trainingCategoryList: [],
      englishCategoryList: [],
      displayAEDetail: false,
      displaySummary: false,
      displayAEOnly: false,
      displayTrainingOnly: false,
      isLoadedData: false,
      vipUnconsumedTotalAmount: 0,
      isLoadVipUnconsumedTotalAmount: false
    };
  },
  components: {
    navigator,
    fileUploader,
    studentCourseReview,
  },
  computed: {},
  created() {
    this.displaySummary =
      this.USERMANAGER.isAdmin ||
      this.USERMANAGER.isFinancialManager ||
      this.USERMANAGER.isExecutiveManager ||
      this.USERMANAGER.isRegionCEO ||
      this.USERMANAGER.isSales ||
      this.USERMANAGER.isReceptionist ||
      this.USERMANAGER.isAcademicDirector ||
      this.USERMANAGER.isRegionCEO ||
      this.USERMANAGER.isCampusPresident ||
      this.USERMANAGER.isVocationalTrainingManager;
    this.displayAEOnly =
      this.USERMANAGER.isSales ||
      this.USERMANAGER.isReceptionist ||
      this.USERMANAGER.isRegionCEO ||
      this.USERMANAGER.isCampusPresident;
    this.displayTrainingOnly = this.USERMANAGER.isVocationalTrainingManager;

    this.loadVipUnconsumedTotalAmount();

    this.courseTypeList = getCourseTypeList();
    this.courseTypeList.splice(0, 0, { Key: 0, Value: "所有类型" });
    this.searchCondition.courseType = 0;

    this.loadStudentSpeedupCourse();
    this.loadStudentFinacialSummary();
    getTerms(true).then((result) => {
      if (!!result && result.success) {
        this.termList = result.data;
        let currentTerm = result.data.find((i) => i.IsCurrentTerm);
        if (!!currentTerm) {
          this.searchCondition.termId = currentTerm.Id;
        }
      }
    });
    getTrainingCategoryList(3).then((result) => {
      if (!!result && result.success) {
        this.trainingCategoryList = result.data;
        this.trainingCategoryList.splice(0, 0, {
          Id: 0,
          Name: "所有业务",
        });
        this.searchCondition.trainingCategoryId = 0;
      }
    });
    getTrainingCategoryList(2).then((result) => {
      if (!!result && result.success) {
        this.englishCategoryList = result.data;
        this.englishCategoryList.splice(0, 0, {
          Id: 0,
          Name: "所有业务",
        });
        this.searchCondition.englishCategoryId = 0;
      }
    });
  },
  methods: {
    loadVipUnconsumedTotalAmount(){
      if (this.displaySummary && !this.displayAEOnly && !this.displayTrainingOnly){
        this.isLoadVipUnconsumedTotalAmount = true;
        getVipUnconsumedTotalAmount(this.searchCondition.universityId).then(result =>{
          if (result && result.success){
            this.vipUnconsumedTotalAmount = result.data;
          }
          this.isLoadVipUnconsumedTotalAmount = false;
        });
      }
    },
    onClickTotalAECount() {
      this.displayAEDetail = true;
    },
    loadTrainingTermList(callback) {
      if (!this.searchCondition.trainingCategoryId) {
        if (callback) {
          callback();
        }
        return;
      }
      getTrainingTerms(true, this.searchCondition.trainingCategoryId).then(
        (result) => {
          if (!!result && result.success) {
            this.trainingTermList = result.data;
            let currentTerm = result.data.find((i) => i.IsCurrentTerm);
            if (!!currentTerm) {
              this.searchCondition.trainingTermId = currentTerm.Id;
              if (callback) {
                callback();
              }
              return;
            }
          }
        }
      );
    },
    onTrainingCategoryChange() {
      this.loadTrainingTermList(() => {
        this.onSearchConditionChanged();
      });
    },
    closeStudentCourse() {
      this.displayStudentCourse = false;
    },
    onDialogFormVisibleEvent(visible) {
      this.displayStudentCourse = visible;
    },
    getSearchConditions() {
      let conditions = {
        phone: this.searchCondition.phone,
        universityId: this.searchCondition.universityId,
        isConfigured: this.searchCondition.isConfigured,
        isEnroll: this.searchCondition.isEnroll,
        isAuld: this.searchCondition.isAuld,
        isApplyCourse: this.searchCondition.isApplyCourse,
        courseType: this.searchCondition.courseType,
        courseCode: this.searchCondition.courseCode,
        termId: "",
        categoryId: "",
      };
      if (this.searchCondition.courseType == 1) {
        conditions.termId = this.searchCondition.termId;
      } else if (this.searchCondition.courseType == 2) {
        conditions.categoryId = this.searchCondition.englishCategoryId;
      } else {
        conditions.termId = this.searchCondition.trainingTermId;
        conditions.categoryId = this.searchCondition.trainingCategoryId;
      }
      return conditions;
    },
    loadStudentSpeedupCourse() {
      if (!this.isActive) {
        return;
      }
      
      this.loading = true;
      let conditions = this.getSearchConditions();
      this.isLoadedData = true;
      getStudentSpeedupCourse(
        conditions,
        this.currentPage,
        this.currentPageSize,
        "Phone"
      ).then((result) => {
        if (!!result && result.success) {
          this.studentList = result.data.PageList;
          this.recordTotal = result.data.RecordTotal;
          this.clickedStudentList = [];
          this.studentList.forEach((element) => {
            this.clickedStudentList.push(false);
          });
        }
        this.loading = false;
      });
    },
    loadStudentFinacialSummary() {
      getStudentFinacialSummary(this.searchCondition.universityId).then(
        (result) => {
          if (!!result && result.success) {
            this.studentFinancialSummary = result.data;
          }
        }
      );
    },
    onUniversityChange() {
      this.onSearchConditionChanged();
      this.loadStudentFinacialSummary();
      this.loadVipUnconsumedTotalAmount();
    },
    onSearchConditionChanged() {
      this.currentPage = 1;
      this.loadStudentSpeedupCourse();
    },
    handleSizeChange(value) {
      this.currentPageSize = value;
      this.currentPage = 1;
      this.loadStudentSpeedupCourse();
    },
    handleCurrentChange(index) {
      this.currentPage = index;
      this.loadStudentSpeedupCourse();
    },
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    checkIsClicked(index) {
      return this.clickedStudentList[index];
    },
    showStudentCourseSchedule(index, row) {
      let list = [];
      this.clickedStudentList.forEach((element) => {
        list.push(element);
      });
      list[index] = true;
      this.clickedStudentList = list;

      row.isClicked = true;
      this.currentStudentData = {
        termId: this.searchCondition.termId,
        studentId: row.StudentId,
        phone: row.Phone,
        universityName: row.UniversityName,
        speedupCourse: row.SpeedupCourseNames,
      };
      this.displayStudentCourse = true;
      // this.$router.push({
      //   path: "/admin/studentCourseReview",
      //   query: {
      //     studentId: row.StudentId,
      //     phone: row.Phone,
      //     universityName: row.UniversityName,
      //     speedupCourse: row.SpeedupCourseNames
      //   }
      // });
    },
    showStudentProfile(row) {
      //debugger;
      this.$router.push({
        path: "/studentProfile",
        query: {
          studentId: row.StudentId,
        },
      });
    },
    async statusToggle(index, row) {
      var studentIdList = [];
      studentIdList.push(row.StudentId);
      if (row.Enable) {
        await disableStudent(studentIdList).then((result) => {
          if (!!result && result.success) {
            if (result.data) {
              row.Enable = false;
            }
          }
        });
      } else {
        await enableStudent(studentIdList).then((result) => {
          if (!!result && result.success) {
            if (result.data) {
              row.Enable = true;
            }
          }
        });
      }
    },
    statusToggleAll(status) {
      let text = "禁用";
      if (status) {
        text = "解禁";
      }
      this.$confirm("您确定要" + text + "所有学生吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var studentIdList = [];
          this.studentList.forEach((item, i) => {
            studentIdList.push(item.StudentId);
          });
          let conditions = this.getSearchConditions();
          if (!status) {
            this.isDisableLoading = true;
            disableStudentAll(conditions).then((result) => {
              if (!!result && result.success) {
                if (result.data) {
                  this.loadStudentSpeedupCourse();
                }
              }
              this.isDisableLoading = false;
            });
          } else {
            this.isEnableLoading = true;
            enableStudentAll(conditions).then((result) => {
              if (!!result && result.success) {
                if (result.data) {
                  this.loadStudentSpeedupCourse();
                }
              }
              this.isEnableLoading = false;
            });
          }
        })
        .catch(() => {});
    },
    onCloseEditor() {
      this.fileUploaderVisible = false;
      this.fileUploaderCloseVisible = true;
    },
    onFileBeforeUpload() {
      this.fileUploaderCloseVisible = false;
    },
    onFileUploadError() {
      this.fileUploaderCloseVisible = true;
    },
    onFileUploaded() {
      this.fileUploaderVisible = false;
      this.loadStudentSpeedupCourse();
      this.fileUploaderCloseVisible = true;
      // await importStudentSpeedupCourse().then((result)=>{
      //     if(callback){
      //         callback(result);
      //         this.loadStudentSpeedupCourse();
      //     }
      // });
    },
    uploadTest() {
      this.fileUploaderVisible = true;
    },
    importStudents() {
      this.fileUploaderVisible = true;
    },
  },
  watch:{
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
        this.loadStudentSpeedupCourse();
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/studentList/universityStudentList.vue